import * as React from "react";
import { useTranslation } from "react-i18next";
import useServerText from "util/serverText";
import { useGetStatuses } from "security-app/hooks/useInvestigationsAPI";
import { Spinner } from "components/common";
const StatusValue = ({ statusName }) => {
  const { t } = useTranslation("enterprise_security_investigations");
  const serverText = useServerText();
  const { statuses, loadingStatuses } = useGetStatuses();
  if (loadingStatuses) {
    return /* @__PURE__ */ React.createElement(Spinner, null);
  }
  const status = statuses.find(({ status: statName }) => statusName === statName);
  if (status) {
    return /* @__PURE__ */ React.createElement(React.Fragment, null, serverText(status.status));
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, t("widget_filters.unknown"));
};
export default StatusValue;
